import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from './environments/environment';


@Injectable()
export class AuthService {	
 
  constructor(private http: HttpClient, private spinnerService: Ng4LoadingSpinnerService,) {
  }
  baseUrl = environment.baseUrl;
 
  public get currentUserValue(): any {
        return JSON.parse(localStorage.getItem('currentuser'));
    }
  login(emailid: string, password: string): Observable<boolean> {
	  this.spinnerService.show(); 
    console.log("This is in Frontend---- base Url",this.baseUrl);   
    return this.http.post<{token: string}>(this.baseUrl + '/api/users/auth', {emailid: emailid, password: password})
    .pipe(
      map(userinfo => {
        console.log("This is in Frontend---- base Url",userinfo.token);   
        localStorage.setItem('access_token', userinfo.token);		
          localStorage.setItem('currentuser', JSON.stringify(userinfo));		
		     this.spinnerService.hide();    
		 
          return true;
        })
      );
      
  }

  logout() {
    localStorage.removeItem('access_token');
	localStorage.removeItem('currentuser');
  }

  public get loggedIn(): boolean {
    return (localStorage.getItem('access_token') !== null);
  }
  
  
}